// src/pages/LandingPage.jsx
import React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import Hero from '../components/common/landing/Hero';
import Features from '../components/common/landing/Features';
import HowItWorks from '../components/common/landing/HowItWorks';
import Testimonials from '../components/common/landing/Testimonials';
import Pricing from '../components/common/landing/Pricing';
import CTASection from '../components/common/landing/CTASection';

const LandingPage = () => {
  return (
    <div className="landing-page min-h-screen bg-white dark:bg-gray-900">
      <Header isLanding={true} />
      <Hero />
      <Features />
      <HowItWorks />
      <Testimonials />
      <Pricing />
      <CTASection />
      <Footer />
    </div>
  );
};

export default LandingPage;